import { render, staticRenderFns } from "./OrganisationLogoUploader.vue?vue&type=template&id=380a2a5a&scoped=true"
import script from "./OrganisationLogoUploader.vue?vue&type=script&lang=js"
export * from "./OrganisationLogoUploader.vue?vue&type=script&lang=js"
import style0 from "./OrganisationLogoUploader.vue?vue&type=style&index=0&id=380a2a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380a2a5a",
  null
  
)

export default component.exports